// "Como jogar" -- a mesma pagina do 38 Brasil, em secoes numeradas.

import React from 'react';
import { LEAGUES } from '../data/leagues.js';
import { MONEY, money } from '../engine/economy.js';
import { PREMIUM } from './premium-config.js';

const S = ({ n, title, children }) => (
  <section>
    <h2><span className="num">{n}</span>{title}</h2>
    {children}
  </section>
);

export function HowTo({ onBack, onNew }) {
  return (
    <>
      <div className="topbar">
        <div className="inner">
          <div className="row" style={{ gap: 8 }}>
            <button className="ghost sm" onClick={onBack}>voltar</button>
            <div className="brand">82 <b>Basquete</b></div>
          </div>
          <div className="meta">Como jogar</div>
        </div>
      </div>

      <div className="wrap howto">
        <p className="kicker">• Guia</p>
        <h1 style={{ fontSize: 24, margin: '4px 0 6px' }}>Como jogar o 82 Basquete</h1>
        <p className="muted">
          Voce e o tecnico: escolhe o clube, monta o elenco, negocia no mercado,
          escolhe no draft e leva o time ao titulo. Da para ler em dois minutos.
        </p>

        <S n="1" title="Escolha a liga e o clube">
          <p>
            Sao duas ligas, e o formato de cada uma e diferente de verdade:
          </p>
          <ul>
            <li>
              <b>{LEAGUES.nbb.name}</b> — {LEAGUES.nbb.teams.length} times, liga unica,
              {' '}{LEAGUES.nbb.regularRounds} rodadas de turno e returno, playoffs em melhor
              de 5. Periodos de 10 minutos, placar tipico de 85 pontos. <b>Gratis.</b>
            </li>
            <li>
              <b>{LEAGUES.nba.name}</b> — {LEAGUES.nba.teams.length} times em duas conferencias,
              {' '}{LEAGUES.nba.regularRounds} rodadas, playoffs em melhor de 7. Periodos de 12
              minutos, placar tipico de 114 pontos.
            </li>
          </ul>
          <p>
            Times e elencos sao reais. Cada clube comeca com o grupo que tem de
            verdade, e dali em diante a carreira e sua: quem sai, quem chega e
            quem cresce depende do que voce fizer.
          </p>
        </S>

        <S n="2" title="Jogue a temporada">
          <p>
            No painel voce ve o proximo adversario e tem dois caminhos:
          </p>
          <ul>
            <li><b>▶ Jogar</b> — assiste a partida ao vivo, com cronometro, placar e
              narracao jogada a jogada. Da para pausar, acelerar ou pular para o fim.</li>
            <li><b>Simular</b> — o resultado sai na hora, sem assistir.</li>
            <li><b>+5 / +20 rodadas</b> — avanca varias de uma vez.</li>
          </ul>
          <p>
            Os dois caminhos usam a MESMA simulacao: assistir nao muda o resultado.
          </p>
        </S>

        <S n="3" title="Cuide do elenco">
          <p>
            Cada atleta tem overall (o que ele e hoje), potencial (o teto), valor de
            mercado, salario e contrato. A rotacao e automatica e seque os minutos-alvo,
            que saem da qualidade de cada um.
          </p>
          <ul>
            <li>Toque num atleta para ver estatisticas da temporada e atributos.</li>
            <li><b>Por na lista de transferencias</b> atrai propostas dos outros clubes.</li>
            <li><b>Dispensar</b> custa dinheiro e nao devolve nada.</li>
          </ul>
        </S>

        <S n="4" title="Negocie no mercado">
          <p>
            O preco pedido por um atleta e o valor de mercado dele mais uma margem —
            e o <b>interesse dele</b> mexe nesse preco. Clube grande atrai, banco
            espanta, e salario alto compensa.
          </p>
          <ul>
            <li>Ofereca mais salario e veja o preco pedido cair na mesma tela.</li>
            <li>Proposta perto do pedido volta como <b>contraproposta</b>.</li>
            <li>Nas propostas que voce recebe da para aceitar, recusar ou contrapor —
              mas se pedir demais, o comprador desiste.</li>
            <li>O mercado fecha na data limite de trocas e reabre na entressafra.</li>
          </ul>
        </S>

        <S n="5" title="Respeite o teto salarial">
          <p>
            Nao adianta ter caixa se o salario nao cabe. Na NBA o teto e
            {' '}{money(MONEY.salaryCap)} e no NBB e {money(LEAGUES.nbb.economy.salaryCap)}.
            Passar dele nao e proibido: custa <b>imposto de luxo</b> na virada de
            temporada. O elenco tambem tem piso e teto de atletas.
          </p>
        </S>

        <S n="6" title="Playoffs">
          <p>
            Os melhores classificados avancam. Cada serie e melhor de 5 ou de 7,
            conforme a liga e a fase, com mando de quadra 2-2-1-1-1 para o melhor
            classificado. Quem vence a ultima serie e campeao.
          </p>
        </S>

        <S n="7" title="Draft">
          <p>
            Na entressafra vem o draft, como e feito hoje. Na NBA, os times fora dos
            playoffs entram na <b>loteria</b>: as tres piores campanhas tem 14% cada de
            ficar com a primeira escolha. As quatro primeiras saem do sorteio; o resto
            e ordem inversa da classificacao, e o campeao escolhe por ultimo.
          </p>
          <p>
            O board mostra o que o <b>olheiro</b> acha — uma faixa de teto estimado, nunca
            o numero real. Calouro entra cru: o que ele traz e potencial, nao presente.
          </p>
        </S>

        <S n="8" title="O que e pago">
          <p>
            O <b>{LEAGUES.nbb.name} e gratis e completo</b>: temporada, playoffs, mercado e
            draft. O <b>{PREMIUM.name}</b> ({PREMIUM.priceLabel}, {PREMIUM.kind}) abre a NBA
            e o save na nuvem. E um Pix so, sem mensalidade.
          </p>
        </S>

        <button className="cta" style={{ marginTop: 18 }} onClick={onNew}>
          <span className="ic">🏀</span>
          <span>
            <span className="tt">Comecar carreira</span>
            <span className="ss">Da para aprender jogando</span>
          </span>
          <span className="arrow">›</span>
        </button>
        <div style={{ height: 30 }} />
      </div>
    </>
  );
}
